import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import DemoCreationScene from 'components/coachSalesPages/DemoCreationScene'

function mapStateToProps(state, ownProps) {
  const { paymentReducer } = state;
  return {
    planOptions: paymentReducer.get('plans'),
    logo: paymentReducer.get('logo'),
    stripePubKey: paymentReducer.get('stripePubKey'),
    siteCheckout: paymentReducer.get('siteCheckout'),
    productName: paymentReducer.get('productName'),
    checkoutMethod: paymentReducer.get('checkoutMethod'),
    accessType: paymentReducer.get('accessType'),
    temp_hana_checkoutMethod: paymentReducer.get('temp_hana_checkoutMethod'),
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: {
      paymentActions: bindActionCreators(require('actions/paymentActions'), dispatch),
      signUpActions: bindActionCreators(require('actions/signUpActions'), dispatch)
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DemoCreationScene);


// WEBPACK FOOTER //
// ./src/containers/DemoCreationContainer.js